export enum TimePeriod {
  ThisWeek = 'thisWeek',
  LastWeek = 'lastWeek',
  ThisMonth = 'thisMonth',
  LastMonth = 'lastMonth',
  ThisYear = 'thisYear',
  LastYear = 'lastYear',
  Today = 'today',
  Custom = 'custom',
  Last7Days = 'last7Days',
  Last30Days = 'last30Days',
  firstQuarter = 'firstQuarter',
  secondQuarter = 'secondQuareter',
  thirdQuarter = 'thirdQuarter',
  fourthQuarter = 'fourthQuarter'
}

export enum Periods {
  Years = 'years',
  Months = 'months',
  Days = 'days',
  Hours = 'hours'
}

export enum VisitTypes {
  Asynchronous = 'asynchronous',
  Synchronous = 'synchronous',
  SynchronousConnectedPhone = 'synchronous_connected_phone'
}

export enum VisitStatuses {
  Active = 'active',
  Reassigned = 'reassigned',
  Expired = 'expired',
  Completed = 'completed',
  CompletedForFutureUsage = 'completed_for_future_usage'
}

// ORDER
export enum OrderStatuses {
  Started = 'started',
  RequiresOrderSubmission = 'requires_order_submission',
  RequiresAdminReview = 'requires_admin_review',
  RequiresFeeWriteOff = 'requires_fee_write_off',
  RequiresMedicalSpecialistAppointment = 'requires_medical_specialist_appointment',
  RequiresProviderReview = 'requires_provider_review',
  RequiresPharmacyDispatch = 'requires_pharmacy_dispatch',
  RejectedByProvider = 'rejected_by_provider',
  RequiresPharmacyData = 'requires_pharmacy_data',
  RequiresPharmacyResponse = 'requires_pharmacy_response',
  RequiresFulfillment = 'requires_fulfillment',
  WaitingForAttachedQuestionnaire = 'waiting_for_attached_questionnaire',
  PharmacyApproved = 'pharmacy_approved',
  PharmacyRejected = 'pharmacy_rejected',
  PharmacyDeliveryInProgress = 'pharmacy_delivery_in_progress',
  PharmacyShipped = 'pharmacy_shipped',
  Delivered = 'delivered',
  Cancelled = 'cancelled',
  Completed = 'completed',
  Stale = 'stale',
  Delayed = 'delayed',
  RenewalPending = 'renewal_pending',
  ProcessedExternally = 'processed_externally',
  Failed = 'failed',
  Submitted = 'submitted',
  ShippingDepartment = 'shipping_department',
  RequiresWaitingRoomEgress = 'requires_waiting_room_egress',
  RequiresOrderProcessing = 'requires_order_processing',
  RequiresAffiliateReview = 'requires_affiliate_review',
  RequiresPrerequisiteCompletion = 'requires_prerequisite_completion'
}

export enum LabOrderStatuses {
  Pending = 'pending',
  InProgress = 'in_progress',
  Complete = 'complete'
}

export enum RequisitionStatuses {
  PendingApproval = 'pending_approval',
  InProgress = 'in_progress',
  Completed = 'completed'
}

export enum LabVisitTypes {
  AppointmentOnsiteVisits = 'appointment_onsite',
  WalkInOnsiteVisits = 'walk_in_onsite',
  MobileVisits = 'mobile',
  PatientAdministeredAtHome = 'patient_administered_at_home'
}

// PATIENT
export enum PatientStatuses {
  Active = 'active'
}

export enum PatientRoles {
  Patient = 'patient'
}

export enum Genders {
  Female = 'female',
  Male = 'male',
  Other = 'other'
}

export enum TableColumnType {
  Text = 'text',
  Link = 'link',
  Render = 'render',
  LinkTextTag = 'link_text_tag',
  Tag = 'tag',
  LinkTextTooltip = 'link_text_tooltip',
  Action = 'action',
  Redirect = 'redirect'
}

export enum PaymentMechanism {
  PatientPay = 'patient_pay',
  AffiliatePay = 'affiliate_pay'
}

export enum TabsPosition {
  Vertical = 'vertical',
  Horizontal = 'horizontal'
}

export enum FormItemType {
  Input = 'input',
  Email = 'email',
  Password = 'password',
  Checkbox = 'checkbox',
  DatePicker = 'datepicker',
  RangePicker = 'rangepicker',
  CheckboxAgreement = 'checkboxagreement',
  PhoneInput = 'phoneinput',
  Select = 'select',
  ReCaptcha = 'recaptcha',
  ReCaptchaV3 = 'recaptcha_v3',
  BirthdayInput = 'birthday',
  CodeInput = 'codeinput',
  RadioGroup = 'radiogroup',
  Switch = 'switch',
  ConditionalInput = 'conditionalinput',
  SearchInput = 'searchInput'
}

export enum ErrorMessages {
  Required = 'This field is required.',
  MaxLength = 'This field is too long.',
  MinLength = 'This field is too short.',
  PatternLatin = 'This field can contain only latin letters.',
  PatternLetters = 'This field can only contain letters.',
  PatternEmail = 'Invalid email address.',
  PatternPhone = 'Invalid phone number.',
  PatternNumbers = 'This field can only contain numbers.',
  Password = 'The passwords do not match.',
  Url = 'Please enter a valid website URL (e.g. http://www.domain.com).',
  minHeightNumber = 'The height must be at least 20 inches',
  maxHeightNumber = 'The height must be less than 100 inches',
  minWeightNumber = 'The weight must be at least 40 lbs',
  maxWeightNumber = 'The weight must be less than 660 lbs'
}

export enum UserRoles {
  AffiliateSuperAdmin = 'affiliate-super-admin',
  AffiliateAdmin = 'affiliate-admin',
  AffiliateAgent = 'affiliate-agent'
}

export enum UserStatus {
  Active = 'active',
  Inactive = 'inactive'
}

export enum QuestionnaireInstanceStatuses {
  Filled = 'filled',
  InProgress = 'inprogress',
  ApprovedByProvider = 'approved_by_provider',
  Stale = 'stale',
  Expired = 'expired',
  Completed = 'completed'
}

export enum EventTypes {
  PrescriptionRenew = 'prescription_renew',
  SubscriptionsRenew = 'subscription_renew',
  FormStarted = 'form_started',
  ProductRequest = 'product_request',
  NewStatusSetToRequest = 'new_status_set_to_request',
  NoAvailableProviders = 'no_available_providers',
  ProviderAssigned = 'provider_was_assigned',
  ProviderReassigned = 'provider_was_reassigned',
  BillingDetailsCompleted = 'billing_details_completed',
  PrescriptionCancelled = 'prescription_cancelled',
  ShippingDetailsSet = 'shipping_details_set',
  ShipmentDelivered = 'shipment_delivered',
  PrescriptionSentToPharmacy = 'prescription_sent_to_pharmacy',
  GeneratingPrescription = 'generating_prescription',
  PharmacyFulfilledPrescription = 'pharmacy_fulfilled_prescription',
  PharmacyProcessingPrescription = 'pharmacy_processing_prescription',
  PharmacySentPrescription = 'pharmacy_sent_prescription',
  PharmacyRejectedPrescription = 'pharmacy_rejected_prescription',
  AddressAppendedToOrder = 'address_appended_to_order',
  AddressAppendedToSubscription = 'address_appended_to_subscription',
  OrderSubmitted = 'order_submitted',
  OrderPaymentCollected = 'order_payment_collected',
  OrderCreated = 'order_created',
  PrescriptionDocumentGenerated = 'prescription_document_generated',
  InitializePrescriptionRenewal = 'initialize_prescription_renewal',
  UnhandledEvent = 'unhandled_event',
  PrescriptionRefill = 'prescription_refill',
  ConsultationStatusUpdated = 'consultation_status_updated',
  SendConsultationsPrescriptions = 'send_consultations_prescriptions',
  RecommendationAccepted = 'recommendation_accepted',
  RecommendationRejected = 'recommendation_rejected',
  // AFFILIATE
  FormIntentResolved = 'form_intent_resolved',
  ExternalOrderReceivedWoocommerce = 'external_order_received',
  ExternalOrderReceivedWoocommerceError = 'external_order_received_error',
  ExternalOrderReceivedGroupon = 'external_order_received_groupon',
  AbandonedCart = 'abandoned_cart',
  ConsultationBilledToPatient = 'consultation-billed-to-patient',
  ConsultationBilledToAffiliate = 'consultation-billed-to-affiliate'
}

export enum EntityModels {
  Patient = 'Patient',
  Practitioner = 'Practitioner',
  User = 'User',
  Affiliate = 'Affiliate',
  Order = 'Order',
  LabOrder = 'LabOrder',
  Questionnaire = 'Questionnaire',
  QuestionnaireInstance = 'QuestionnaireInstance',
  Location = 'Location',
  FormResponse = 'FormResponse',
  Address = 'Address',
  Prescription = 'Prescription',
  PrescriptionFulfillment = 'PrescriptionFulfillment',
  Note = 'Note',
  Consultation = 'Consultation',
  Visit = 'Visit',
  EncoreVisit = 'EncoreVisit',
  Subscription = 'Subscription',
  ProductVariation = 'ProductVariation',
  Product = 'Product',
  Recommendation = 'Recommendation'
}

export enum PaymentIntentStatuses {
  RequiresPaymentMethod = 'requires_payment_method',
  RequiresSource = 'requires_source',
  RequiresConfirmation = 'requires_confirmation',
  RequiresAction = 'requires_action',
  RequiresSourceAction = 'requires_source_action',
  Processing = 'processing',
  Succeeded = 'succeeded',
  Canceled = 'canceled',
  Success = 'success',
  ApprovedReview = 'approvedReview',
  AuthorizedPendingCapture = 'authorizedPendingCapture',
  AuthorizedHeldPendingRelease = 'authorizedHeldPendingRelease',
  CapturedPendingSettlement = 'capturedPendingSettlement',
  CouldNotVoid = 'couldNotVoid',
  Declined = 'declined',
  Expired = 'expired',
  FDSAuthorizedPendingReview = 'FDSAuthorizedPendingReview',
  FDSPendingReview = 'FDSPendingReview',
  FailedReview = 'failedReview',
  OrderNotComplete = 'orderNotComplete',
  Refund = 'refund',
  RefundPendingSettlement = 'refundPendingSettlement',
  SettledSuccessfully = 'settledSuccessfully',
  UnderReview = 'underReview',
  Voided = 'voided',
  PaymentIntentPending = 'payment_intent_pending',
  RequiresCapture = 'requires_capture'
}
export enum PaymentBrand {
  Visa = 'visa',
  MasterCard = 'mastercard'
}
export enum NotificationMessages {
  Error = 'error',
  Success = 'success',
  Information = 'information'
}

export enum TwoFATypes {
  None = 'none',
  Sms = 'sms',
  Email = 'email'
}
export enum WebhookInterestsModel {
  PrescriptionRenew = 'prescription_renew',
  SubscriptionRenew = 'subscription_renew',
  FormStarted = 'form_started',
  ProductRequest = 'product_request',
  NewStatusSetToRequest = 'new_status_set_to_request',
  NoAvailableProviders = 'no_available_providers',
  ProviderWasAssigned = 'provider_was_assigned',
  ProviderWasReassigned = 'provider_was_reassigned',
  BillingDetailsCompleted = 'billing_details_completed',
  PrescriptionCancelled = 'prescription_cancelled',
  ShippingDetailsSet = 'shipping_details_set',
  ShipmentDelivered = 'shipment_delivered',
  PrescriptionSentToPharmacy = 'prescription_sent_to_pharmacy',
  GeneratingPrescription = 'generating_prescription',
  PharmacyBundleFax_Sent = 'pharmacy_bundle_fax_sent',
  PharmacyFulfilledPrescription = 'pharmacy_fulfilled_prescription',
  PharmacyProcessingPrescription = 'pharmacy_processing_prescription',
  PharmacySentPrescription = 'pharmacy_sent_prescription',
  PharmacyRejectedPrescription = 'pharmacy_rejected_prescription',
  AddressAppendedToOrder = 'address_appended_to_order',
  AddressAppendedToSubscription = 'address_appended_to_subscription',
  OrderSubmitted = 'order_submitted',
  OrderPaymentCollected = 'order_payment_collected',
  OrderCreated = 'order_created',
  OrderExpedited = 'order_expedited',
  PrescriptionDocumentGenerated = 'prescription_document_generated',
  InitializePrescriptionRenewal = 'initialize_prescription_renewal',
  UnhandledEvent = 'unhandled_event',
  PrescriptionRefill = 'prescription_refill',
  ConsultationStatusUpdated = 'consultation_status_updated',
  SendConsultationsPrescriptions = 'send_consultations_prescriptions',
  RecommendationAccepted = 'recommendation_accepted',
  RecommendationRejected = 'recommendation_rejected',
  FormIntentResolved = 'form_intent_resolved',
  ExternalOrderReceived = 'external_order_received',
  ExternalOrderReceivedError = 'external_order_received_error',
  ExternalOrderReceivedGroupon = 'external_order_received_groupon',
  AbandonedCart = 'abandoned_cart',
  ConsultationBilledToPatient = 'consultation-billed-to-patient',
  ConsultationBilledToAffiliate = 'consultation-billed-to-affiliate'
}
export enum WebhooksStatuses {
  Active = 'active',
  Disabled = 'disabled'
}

export enum NoteTypes {
  Standard = 'standard',
  Soap = 'soap'
}

export enum LocationTypes {
  Question = 'question',
  Section = 'section',
  Informational = 'informational',
  Start = 'start',
  Task = 'task',
  Upload = 'upload'
}

export enum DataTypes {
  Input = 'input',
  NumberInput = 'numberInput',
  Select = 'select',
  Radio = 'radio',
  Upload = 'upload',
  Table = 'table',
  Signature = 'signature',
  MultipleInput = 'multipleInput',
  CheckboxGroup = 'checkboxGroup',
  Agreement = 'agreement',
  Date = 'date'
}

export enum UniversalSelectModes {
  Single = 'single',
  Multiple = 'multiple'
}

export enum TYPEFORM_FIELD_TYPES {
  BOOLEAN = 'boolean',
  TEXT = 'text',
  PHONE_NUMBER = 'phone_number',
  EMAIL = 'email',
  CHOICE = 'choice',
  CHOICES = 'choices',
  NUMBER = 'number',
  FILE_URL = 'file_url',
  STATEMENT = 'statement',
  GROUP = 'group'
}

export enum ExternalQuestionnaireSources {
  TypeForm = 'typeform'
}

export enum TypeFormModes {
  Widget = 'widget',
  Popup = 'popup',
  Slider = 'slider',
  Sidetab = 'sidetab',
  Popover = 'popover'
}

export enum PVQuantityValues {
  min = '1',
  max = '6'
}

export enum SettingsPageMenuOptions {
  Company = 'company',
  Details = 'details',
  PaymentMethod = 'payment-method',
  UserManagement = 'user-management',
  Patients = 'patients',
  Projects = 'projects',
  Communications = 'communications',
  ProductList = 'product-list',
  Tags = 'tags',
  TagManagement = 'tag-management',
  PaymentProcessor = 'payment-processor',
  Ctrl = 'ctrl',
  Credentials = 'credentials'
}

export enum CardContentPositions {
  Bottom = 'bottom',
  Inline = 'inline'
}

export enum PaymentProcessors {
  AuthNet = 'authnet',
  Stripe = 'stripe'
}

export enum AuthNetEnvironment {
  Sandbox = 'SANDBOX',
  Production = 'PRODUCTION'
}

export enum PrerequisiteInstanceStatus {
  Incomplete = 'incomplete',
  Complete = 'complete'
}

export enum CategoryTabs {
  Status = 'status',
  VisitType = 'visitType',
  Practitioner = 'practitioner'
}

export enum CorrespondenceManager {
  Telegra = 'telemdnow-system',
  External = 'affiliate-system'
}

export enum Collections {
  Orders = 'orders',
  LabOrders = 'lab-orders',
  Patients = 'patients',
  Consultations = 'consultations',
  Transactions = 'transactions',
  JourneyTemplates = 'journey-templates'
}

export enum CommunicationTypes {
  Email = 'email',
  Text = 'text',
  Slack = 'slack'
}

export enum TemplateSources {
  Sendgrid = 'sendgrid'
}

export enum CommunicationLevels {
  Global = 'global',
  Affiliate = 'affiliate'
}

export enum CommunicationTemplateKeys {
  USER_INVITED = 'USER_INVITED',
  AFFILIATE_ADDED = 'AFFILIATE_ADDED',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  TWO_FACTOR_VERIFICATION = 'TWO_FACTOR_VERIFICATION',
  ORDER_LINK = 'ORDER_LINK',
  ORDER_REMINDER = 'ORDER_REMINDER',
  INVITE_PATIENT_COMPLETE_QUESTIONNAIRE = 'INVITE_PATIENT_COMPLETE_QUESTIONNAIRE',
  REQUEST_SUBMITTED = 'REQUEST_SUBMITTED',
  BILLING_UPDATE_LINK = 'BILLING_UPDATE_LINK',
  MESSAGE_RECEIVED = 'MESSAGE_RECEIVED',
  PRESCRIPTION_APPROVED = 'PRESCRIPTION_APPROVED',
  CONSULTATION_FEE_TAKEN = 'CONSULTATION_FEE_TAKEN',
  PRESCRIPTION_SENT_TO_PHARMACY = 'PRESCRIPTION_SENT_TO_PHARMACY',
  SHIPPING_DETAILS_SET = 'SHIPPING_DETAILS_SET',
  QUESTIONNAIRE_REMINDER = 'QUESTIONNAIRE_REMINDER'
}

export enum SampleTypes {
  Blood = 'Blood',
  Urine = 'Urine',
  Saliva = 'Saliva',
  Stool = 'Stool',
  Tissue = 'Tissue',
  Swab = 'Swab',
  Hair = 'Hair',
  Nail = 'Nail',
  Sputum = 'Sputum',
  Fluid = 'Fluid',
  CSF = 'Cerebrospinal Fluid (CSF)'
}

export enum NOTE_TYPES {
  STANDARD = 'standard',
  SOAP = 'soap'
}

export enum LabTestResultType {
  QUANTITY = 'quantity',
  VALUE = 'value'
}

export enum INVITE_TYPES {
  EMAIL = 'email',
  SMS = 'sms'
}

export enum UPLOADER_FILE_FORMATS {
  PDF = '.pdf',
  DOCX = '.docx',
  PNG = '.png',
  JPEG = '.jpeg',
  JPG = '.jpg'
}

export enum JOURNEY_TEMPLATE_TYPE {
  ONE_TIME = 'ONE_TIME',
  SUBSCRIPTION_FIXED = 'SUBSCRIPTION_FIXED',
  SUBSCRIPTION_VARIABLE = 'SUBSCRIPTION_VARIABLE'
}

export enum BILLING_CADENCE_TYPE {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year'
}

export enum PRODUCT_TYPE {
  ONE_TIME = 'ONE_TIME',
  SUBSCRIPTION_FIXED = 'SUBSCRIPTION_FIXED',
  SUBSCRIPTION_VARIABLE = 'SUBSCRIPTION_VARIABLE'
}

export enum SUBSCRIPTION_TYPE {
  ONE_TIME = 'ONE_TIME',
  SUBSCRIPTION_FIXED = 'SUBSCRIPTION_FIXED',
  SUBSCRIPTION_VARIABLE = 'SUBSCRIPTION_VARIABLE'
}

export enum PRODUCT_TYPES_LABELS {
  SUBSCRIPTION_VARIABLE = 'Subscription (Variable)',
  SUBSCRIPTION_FIXED = 'Subscription (Fixed)',
  ONE_TIME = 'One-Time Purchase'
}

export enum SubscriptionStatuses {
  onHold = 'on-hold',
  active = 'active',
  Cancelled = 'cancelled',
  Expired = 'expired',
  Pending = 'pending',
  pendingCancel = 'pending-cancel'
}

export enum EcommerceOrderStatuses {
  onHold = 'on-hold',
  active = 'active',
  Cancelled = 'cancelled',
  Expired = 'expired',
  Pending = 'pending',
  Refunded = 'refunded',
  Paid = 'paid',
  Draft = 'draft',
  Failed = 'failed',
  Completed = 'completed'
}

export enum CouponStatuses {
  active = 'active',
  expired = 'expired',
  disabled = 'disabled',
  draft = 'draft'
}

export enum RefundReason {
  CustomerRequest = 'customer_request',
  DuplicateCharge = 'duplicate_charge',
  Fraudulent = 'fraudulent',
  ProductNotDelivered = 'product_not_delivered',
  ProductDefective = 'product_defective',
  OrderCancelled = 'order_cancelled',
  AdminAdjustment = 'admin_adjustment',
  Other = 'other'
}
